import { ref } from 'vue'

const houseId = ref( '151673' )

const selectedArea = ref( null )

const houseFloorsCount = ref( undefined )

export { houseId, selectedArea, houseFloorsCount }